import { z } from 'zod';

// Schéma du formulaire de référencement (registerTab). Le numéro de série et l'acceptation des
// CGU ne sont exigés que lorsque les champs additionnels sont affichés (première inscription).
export const buildRegisterFormSchema = (requireAdditionalFields: boolean) =>
  z.object({
    clientCode: z.string().trim().min(1, 'Le code client est obligatoire'),
    serialNumber: requireAdditionalFields
      ? z.string().trim().min(1, 'Le numéro de série ou de facture est obligatoire')
      : z.string().optional(),
    isChecked: requireAdditionalFields
      ? z.literal(true, "L'acceptation des conditions générales est obligatoire")
      : z.boolean().optional(),
  });

export type RegisterFormValues = z.infer<ReturnType<typeof buildRegisterFormSchema>>;
